// Textarea que crece con el contenido (extraído de la ficha en la tanda 6 —
// parte 0.3: lo comparten la ficha y la nota de la tabla de medidas). Mínimo
// minRows líneas, máximo maxRows; después scrollea.
import React, { useRef, useEffect, useCallback } from 'react';

export default function AutoTextarea({ value, onChange, placeholder, minRows = 4, maxRows = 12, className = 'pp-input pp-textarea', ...resto }) {
  const ref = useRef(null);
  const ajustar = useCallback((el) => {
    if (!el) return;
    const cs = window.getComputedStyle(el);
    const lh = parseFloat(cs.lineHeight) || 20;
    const pad = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) + 2;
    el.style.height = 'auto';
    const min = lh * minRows + pad;
    const max = lh * maxRows + pad;
    el.style.height = `${Math.min(Math.max(el.scrollHeight, min), max)}px`;
    el.style.overflowY = el.scrollHeight > max ? 'auto' : 'hidden';
  }, [minRows, maxRows]);
  useEffect(() => { ajustar(ref.current); }, [value, ajustar]);
  return (
    <textarea
      ref={ref} className={className} value={value} placeholder={placeholder}
      onChange={(e) => { onChange(e); ajustar(e.target); }}
      {...resto}
    />
  );
}
